document.addEventListener('DOMContentLoaded', function() {
    // Initialize Swiper
    var swiper = new Swiper('.tabitha-swiper-tana', {
      slidesPerView: 1,
      spaceBetween: 20,
      freeMode: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        },
      },
      navigation: {
        nextEl: '.features-swiper-button-next',
        prevEl: '.features-swiper-button-prev',
      }
    });
  
    // Video functionality
    $('.video-show-tana').click(function(){
      $('#iFrame-tana').toggleClass("show-tana");
      $('.video-background-tana').toggleClass('show-tana');
      $('#youtube-video-tana')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    });
  
    $('.tabitha-close-tana').click(function(){
      $('#iFrame-tana').toggleClass("show-tana");
      $('.video-background-tana').toggleClass('show-tana');
      $('#youtube-video-tana')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    
    $('.video-background-tana').click(function(){
      $('#iFrame-tana').toggleClass("show-tana");
      $('.video-background-tana').toggleClass('show-tana');
      $('#youtube-video-tana')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    
    function playVid() {
      document.getElementById("arrow-right-tana").style.width = "110px";
    }
    
    function pauseVid() {
      document.getElementById("arrow-right-tana").style.width = "96px";
    }
    
    function popUp() {
      document.getElementById("iFrame-tana").classList.toggle("show-tana");
      document.querySelector(".video-background-tana").classList.toggle("show-tana");
    }
  });





  document.addEventListener('DOMContentLoaded', function () {
    const showBtn = document.querySelector('.view-detailes-red');
    const hideBtn = document.querySelector('.hide-detailes-red');
    const detailSection = document.querySelector('.perform-test-view');

    if (showBtn && hideBtn && detailSection) {
      showBtn.addEventListener('click', function () {
        showBtn.classList.add('d-none');
        hideBtn.classList.remove('d-none');
        detailSection.classList.remove('d-none');
      });

      hideBtn.addEventListener('click', function () {
        showBtn.classList.remove('d-none');
        hideBtn.classList.add('d-none');
        detailSection.classList.add('d-none');
      });
    }
  });